import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import StatCard from "../StatCard";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/outline";

const CollapsibleStatSection = ({
  title,
  subtitle,
  stats = [],
  defaultOpen = false,
  variant = "default",
  badge,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const variantStyles = {
    overview:
      "border-l-4 border-l-main bg-gradient-to-r from-yellow-50/80 to-white shadow-[0_1px_3px_rgba(0,0,0,0.04)]",
    amadeus:
      "border-l-4 border-l-amber-600 bg-gradient-to-r from-amber-50/60 to-white shadow-[0_1px_3px_rgba(0,0,0,0.04)]",
    ndc: "border-l-4 border-l-sky-600 bg-gradient-to-r from-sky-50/60 to-white shadow-[0_1px_3px_rgba(0,0,0,0.04)]",
    airarabia:
      "border-l-4 border-l-rose-600 bg-gradient-to-r from-rose-50/60 to-white shadow-[0_1px_3px_rgba(0,0,0,0.04)]",
    default:
      "border-l-4 border-l-slate-400 bg-gradient-to-r from-slate-50/80 to-white shadow-[0_1px_3px_rgba(0,0,0,0.04)]",
  };

  return (
    <div
      className={`rounded-2xl overflow-hidden mb-4 border border-slate-200/90 transition-all duration-300 ease-out hover:shadow-[0_4px_12px_rgba(0,0,0,0.06)] hover:border-slate-200 ${
        variantStyles[variant] || variantStyles.default
      }`}
    >
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex gap-3 justify-between items-center px-6 py-4 w-full text-left transition-colors duration-200 focus:outline-none hover:bg-white/60 active:bg-white/80"
      >
        <div className="flex gap-4 items-center">
          <span
            className={`flex items-center justify-center w-9 h-9 rounded-xl transition-transform duration-200 ${
              isOpen ? "bg-slate-200/80" : "bg-slate-100"
            }`}
          >
            {isOpen ? (
              <ChevronDownIcon className="w-5 h-5 text-slate-600" />
            ) : (
              <ChevronRightIcon className="w-5 h-5 text-slate-600" />
            )}
          </span>
          <div>
            <h3 className="text-[15px] font-medium text-slate-800 tracking-wide capitalize">
              {title}
            </h3>
            {subtitle && (
              <p className="text-[13px] text-slate-500 mt-0.5 leading-relaxed">
                {subtitle}
              </p>
            )}
          </div>
          {/* {badge !== undefined && (
            <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-[11px] font-semibold bg-[#fba82c]/15 text-[#c4820a] tracking-wide uppercase">
              {badge} metrics
            </span>
          )} */}
        </div>
        <span className="text-[12px] text-slate-400 font-medium hidden sm:inline">
          {isOpen ? "Collapse" : "Expand"}
        </span>
      </button>
      <Collapse in={isOpen}>
        <div>
          <div className="px-6 pt-2 pb-3">
            <div className="grid grid-cols-1 gap-4 w-full sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {stats.map(({ icon, color, title: statTitle, data }, index) => (
                <StatCard
                  key={`${statTitle}-${index}`}
                  icon={icon}
                  color={color}
                  title={statTitle}
                  data={data}
                  compact
                />
              ))}
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default CollapsibleStatSection;
